import { render, staticRenderFns } from "./ClassroomAvailRow.vue?vue&type=template&id=7fc85e8c&scoped=true&"
import script from "./ClassroomAvailRow.vue?vue&type=script&lang=ts&"
export * from "./ClassroomAvailRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc85e8c",
  null
  
)

export default component.exports